<template lang="pug">
  bloco#assessoria.-padding-desktop
    //- HEADER
    template(slot="header")
      titulo.-withbar.-upper Assessoria
    //- CONTENT
    template(slot="content")
      //- router-link(:to="{ name: 'CGTIndex' }").item
      .item
        bloquinho.-responsive.--grey-hover
          i(slot="icone").proad.proad-estatistica
          template(slot="sigla") ASTEC
          p(slot="texto") À ASTEC compete auxiliar o Pró-Reitor de Administração na gestão da informação orçamentária e demais atribuições.
</template>

<style lang="scss">
  #assessoria {
    .item {
      display: block;
      margin: 0 auto;
      &:hover { text-decoration: none }
      .proad { font-size: 4rem; line-height: 50px; }
    }

    @include media("<desktop") {
      .item { max-width: 140px; }
    }

    @include media(">=desktop") {
      .item { max-width: 400px; }
    }
  }
</style>

<script>
import Bloco from 'COMPONENTS/Bloco'
import Bloquinho from 'COMPONENTS/Bloquinho'
import Titulo from 'COMPONENTS/ElementTitle'
export default {
  components: {
    Bloco,
    Bloquinho,
    Titulo
  }
}
</script>



// WEBPACK FOOTER //
// Assessoria.vue?0fb00210